import '../layout/theme';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { facebookTrackProduct } from '../utils/facebookPixel';
import { getQueryParams } from '../utils/url';
import PdpLayout from './components/pdp/Layout';
import { IdPrefixProvider } from '@jbhi-fi/components/src/IdPrefix';
import { RecaptchaProvider } from '@jbhi-fi/components/src/context/RecaptchaProvider';
import { BaseContentProvider } from './components/stack/components/BaseContentProvider/BaseContentProvider';
import { DefaultLayout } from './components/layout/DefaultLayout';

// Init load before document ready
document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('pdp');
  if (container) {
    const root = createRoot(container);
    root.render(
      <BaseContentProvider shopifyProductActionsProviderProps={{ attachPageType: 'pdp' }}>
        <IdPrefixProvider prefix="pdp">
          <RecaptchaProvider siteKey={window.Jbhifi?.recaptchaSiteKey ?? ''}>
            <DefaultLayout shouldHideCompareBar>
              <PdpLayout />
            </DefaultLayout>
          </RecaptchaProvider>
        </IdPrefixProvider>
      </BaseContentProvider>
    );
  }

  /**
   * Send a GTM event when a breadcrumb is clicked.
   */
  const breadcrumbLinks = document.querySelectorAll('.breadcrumbnav li a, .breadcrumbnav li span');
  if (breadcrumbLinks) {
    breadcrumbLinks.forEach(element => {
      element.addEventListener('click', event => {
        const target = event.target as HTMLSpanElement | HTMLAnchorElement;

        let eventLabel = target?.textContent;
        let eventAction = 'Breadcrumb Valid Link';

        /**
         * Check if the homepage SVG icon was clicked. The event target will be the <path> or <svg> element.
         * Default the label if so.
         */
        if (target?.tagName !== 'A' && target?.tagName !== 'SPAN') {
          eventLabel = '/';
        }

        /**
         * If the target is a span, the collection it is referencing doesn't exist in Shopify.
         */
        if (target?.tagName === 'SPAN') {
          eventAction = 'Breadcrumb Missing Link';
        }

        const gtmEvent = {
          event: 'sendEvent',
          eventCategory: 'Breadcrumb Click',
          eventAction,
          eventLabel,
        };

        window.dataLayer.push(gtmEvent);
      });
    });
  }

  const facebookProductDataJSON = document.querySelector('#facebook-product-data');
  if (facebookProductDataJSON) {
    const facebookProductData = JSON.parse(facebookProductDataJSON.textContent ?? 'null');
    facebookTrackProduct(facebookProductData);
  }

  /**
   * Add product to recently viewed localStorage
   */
  const storedProducts = JSON.parse(localStorage.getItem('recentlyViewed') ?? '[]') || [];
  const viewSku = Number(window.Jbhifi.sku);

  // If sku already in storedProducts, re-order array to bring sku to the front
  if (storedProducts.includes(viewSku)) {
    localStorage.setItem(
      'recentlyViewed',
      JSON.stringify([viewSku, ...storedProducts.filter((item: number) => item !== viewSku)])
    );
  } else {
    // If 12 products (or more), remove last product from storedProducts
    if (storedProducts.length >= 12) {
      storedProducts.pop();
    }
    localStorage.setItem('recentlyViewed', JSON.stringify([viewSku, ...storedProducts]));
  }
});

window.addEventListener('load', function () {
  //Load modal if Notify Me button was clicked from product tile card
  const searchParams: Record<string, any> = getQueryParams();
  if (searchParams?.notifyClicked) {
    document.querySelector<HTMLButtonElement>('.klaviyo-bis-trigger')?.click();
  }
});
